/* Strona pojedynczego kalkulatora — LOADER modulow liczbowych.
 *
 * layout_footer_js.html.twig doladowuje `assets/js/pages/{szablon}.js`
 * automatycznie (autoAsset), a `{% block scripts %}` w szablonie NIE ISTNIEJE
 * w layout.html.twig — do 19.09.2026 kalkulator.html.twig deklarowal ten blok
 * i szesc skryptow w nim nigdy nie trafialo na strone. Kazdy kalkulator
 * bez wzoru w Twigu stal wiec z pustym wynikiem, a te z wzorem nie reagowaly
 * na zmiane pol. Stad ten plik: doladowuje moduly w kolejnosci (adapter po
 * modulach, warstwa DOM na koncu). Kazdy modul dostaje wlasny stempel
 * z ver() w szablonie; data loadera nie wersjonuje jego zaleznosci.
 */
(function () {
    'use strict';
    if (!document.getElementById('kalkulator')) return;

    var manifest = document.getElementById('kalk-assets'), pliki;
    try {
        pliki = JSON.parse(manifest ? manifest.textContent : 'null');
        if (!Array.isArray(pliki) || !pliki.length || !pliki.every(function (url) {
            return typeof url === 'string' && /^\/assets\/js\/[a-z0-9/.-]+\.js\?v=\d+$/.test(url);
        })) throw new Error('assets');
    } catch (_) {
        var blad = document.getElementById('kalk-niedostepny');
        if (blad) blad.hidden = false;
        return;
    }

    var utility = pliki.findIndex(function(url){return url.indexOf('/kalkulatory/uzytkowe.') !== -1;});
    if (utility >= 0) { var u = pliki.splice(utility, 1)[0]; pliki.splice(pliki.findIndex(function(url){return url.indexOf('/kalkulatory/adapter.') !== -1;}), 0, u); }
    function wczytaj(i) {
        if (i >= pliki.length) return;
        var s = document.createElement('script');
        s.src = pliki[i];
        s.onload = function () { wczytaj(i + 1); };
        s.onerror = function () {
            var el = document.getElementById('kalk-niedostepny');
            if (el) el.hidden = false;
        };
        document.head.appendChild(s);
    }
    wczytaj(0);
})();
